/* unplugin-vue-components disabled */import { render } from "./SvipTag.vue?vue&type=template&id=598f3cb8&scoped=true&lang=pug"
import script from "./SvipTag.vue?vue&type=script&setup=true&lang=js"
export * from "./SvipTag.vue?vue&type=script&setup=true&lang=js"

import "./SvipTag.vue?vue&type=style&index=0&id=598f3cb8&lang=stylus&scoped=true"
import "./SvipTag.vue?vue&type=style&index=1&id=598f3cb8&lang=stylus"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598f3cb8"]])

export default __exports__